/* src/app/modules_v2/finance/own-financing/components/own-financing-list/own-financing-list.components.css */
.quick-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}
.total-card {
  background: #fff;
  border-radius: 12px;
  padding: 8px 20px;
  margin: 0;
  text-align: center;
  min-width: 230px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}
.total-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.total-card .label {
  font-size: 13px;
  color: #666;
  margin: 0;
}
@media (max-width: 600px) {
  .total-card {
    min-width: 0;
    width: 100%;
  }
}
/*# sourceMappingURL=own-financing-list.components.css.map */
